/**
 * Newsletter Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/newsletter.liquid
 *
 */

import Vue from 'vue';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import { required, email, minLength, maxLength, sameAs, numeric } from 'vuelidate/lib/validators';

Vue.use(Vuelidate);

Vue.component('newsletter', {
    data() {
        return {
            isNewsletterOpen: false,
            isSubmitting: false,
            isSuccess: false,
            serverMessage: null,
            form: {
                firstName: null,
                lastName: null,
                email: null,
                confirmEmail: null,
                postcode: null
            }
        }
    },

    computed: {
        title: function() {
          return this.isSuccess ? 'success' : 'join';
        }
    },

    validations: {
      form: {
        email: {
          required,
          email
        }
      }
    },

    methods: {
        toggleNewsletter: function() {
            this.isNewsletterOpen = !this.isNewsletterOpen;
        },

        submitForm: function (e) {
            console.log('submit form', e);
            console.log('vuelidator', this.$v);

            this.$v.$touch();

            if (!this.$v.$error) {
                console.log('form is valid');
                this.isSubmitting = true;

                this.form['hasAcceptedMarketking'] = true;
                console.log('form', this.form);

                axios.post('/contact', this.form).then((response) => {
                    console.log(response);
                    this.isSuccess = true;

                }).catch((error) => {
                    console.log(error);
                    this.serverMessage = error.data;

                }).finally(() => {
                    this.isSubmitting = false;
                });

            } else {
                console.log('form is invalid');
            }
        }
    }
});
